import { PropTypes } from 'prop-types';
import React, { Fragment } from 'react';
import { FormattedHTMLMessage } from 'react-intl';
import { makeStyles } from '@material-ui/styles';
import { Typography } from '@material-ui/core';
import { NotificationModel } from '../../models';
import { Button } from 'components/Button';

const useStyles = makeStyles(theme => ({
  button: {
    color: theme.palette.primary.contrastText,
  },
}));

const NotificationHandler = props => {
  const classes = useStyles(props);
  const dismissSnackbar = key => {
    if (key) {
      props.closeSnackbar(key);
    }
  };

  const action = key => (
    <Fragment>
      <Button
        classes={{ root: classes.button }}
        isPrimary={false}
        onClick={() => dismissSnackbar(key)}
        variant="text"
        size="small"
        text="Dismiss"
      />
    </Fragment>
  );

  if (props && props.notifications && props.notifications.length > 0) {
    props.notifications.forEach(notification => {
      props.enqueueSnackbar(
        <Typography variant={'h6'}>
          <FormattedHTMLMessage
            {...(typeof notification.message === 'string'
              ? { id: notification.message }
              : notification.message)}
          />
        </Typography>,
        {
          variant: notification.variant ? notification.variant : 'default',
          action,
          ...notification.options,
        }
      );
    });
  }
  return null;
};

NotificationHandler.propTypes = {
  notifications: PropTypes.arrayOf(PropTypes.shape(NotificationModel)),
};

export default NotificationHandler;
